import _regeneratorRuntime from "@babel/runtime/regenerator";

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(saga);

import { call, all } from 'redux-saga/effects';
import * as Store from '../store';
import manageAuthHeader from './manageAuthHeader';
export default function saga() {
  var sagas, tasks;
  return _regeneratorRuntime.wrap(function saga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          Store.set(Store.keys.SAGA_INITIALIZE, true);
          sagas = [];

          if (Store.get(Store.keys.CONFIG).manageAuthHeader) {
            sagas.push(manageAuthHeader);
          }

          tasks = sagas.map(function (fn) {
            return call(fn);
          });
          _context.next = 6;
          return all(tasks);

        case 6:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, this);
}